export function cacheBurstImage(src: string): string {
  const timestamp = Date.now()
  const separator = src.includes('?') ? '&' : '?'
  return `${src}${separator}cache_burst=${timestamp}`
}
